/* WK 30.09.2026 (Wolf karari): Loox CANLI yorum verisi -- snippets/wk-loox-stats.liquid #bespoky-loox-stats. Sabit sayi YOK. */
window.bespokyLooxText = function (kapsam) {
  var el = document.getElementById('bespoky-loox-stats');
  if (!el) return '';
  var n = function (a) { var v = parseInt(el.getAttribute(a) || '0', 10); return isNaN(v) ? 0 : v; };
  var pr = el.getAttribute('data-p-rating') || '', sr = el.getAttribute('data-s-rating') || '';
  var pc = n('data-p-count'), sc = n('data-s-count');
  if (kapsam !== 'store' && pc > 0 && pr) return pr + ' from ' + pc.toLocaleString('en-US') + (pc === 1 ? ' review' : ' reviews');
  if (sc > 0 && sr) return sr + '/5 from ' + sc.toLocaleString('en-US') + ' store reviews';
  return '';
};
/* Bespoky merged theme fixes — generated 2026-05-27 */
/* Original files: assets/bespoky-custom.js, assets/bespoky-simgym-fixes.js, assets/bespoky-wave2-fixes.js, assets/bespoky-wave3-fixes.js */

/* ===== assets/bespoky-custom.js ===== */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-size-system]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var system = this.getAttribute('data-size-system');
      var parent = this.closest('.rte') || this.closest('.disclosure__content') || this.closest('.content-tabs__panel');
      if (!parent) return;

      parent.querySelectorAll('[data-size-system]').forEach(function(b) {
        b.classList.remove('active');
      });
      this.classList.add('active');

      parent.querySelectorAll('[data-size-panel]').forEach(function(p) {
        p.classList.remove('active');
      });
      var panel = parent.querySelector('[data-size-panel="' + system + '"]');
      if (panel) panel.classList.add('active');
    });
  });
});


/* ===== assets/bespoky-simgym-fixes.js ===== */
/* ==========================================================================
 * Bespoky SimGym MB1 Fixes — Sprint 125 (May 18, 2026)
 * Companion JS for bespoky-simgym-fixes.css
 *
 * Implements:
 *  P0.1 Newsletter popup: delay 30s, one-shot per session, localStorage flag
 *  P0.2 Cart drawer: auto-open after add-to-cart + inject trust row
 *  P0.3 Quick Add: button on each .product-block opens fetch-based mini modal
 *  P0.4 Size Guide: ensure visible trigger on PDP (fallback if not present)
 *  P1.5 PDP Trust signal row: inject under .add-to-cart button
 *  P1.6 Cookie consent: persist dismissal in localStorage to prevent re-show
 *  P1.7 Color swatch hover preview: swap product-block image on hover
 *
 * Loaded via theme.liquid as defer, runs on DOMContentLoaded.
 *
 * 10.07.2026 FIX: P0.4 Size Guide fallback (ensureSizeGuide/openSgFallback)
 * REMOVED — this was stale pre-Sprint-137 embed logic superseded by
 * bespoky-wave3-fixes.js's Sprint 137 direct-navigation-to-/pages/sizing
 * approach (see bindSizeGuideClick() below). Both were shipping together
 * in this bundle; only the newer wave3 behavior should run.
 * ========================================================================== */
(function () {
  'use strict';

  var LS = window.localStorage;
  var NS = 'bespoky_simgym_';

  function lsGet(k) { try { return LS.getItem(NS + k); } catch (e) { return null; } }
  function lsSet(k, v) { try { LS.setItem(NS + k, v); } catch (e) {} }

  /* ----------------------------------------------------------------------
     P0.1 — Newsletter popup behavior override
     - Suppress instant open: hide popup section until 30s elapsed
     - One-shot per session via lsSet('newsletter_dismissed', '1')
     - Replaces aggressive dismiss-day cookie with session-scoped storage
     ---------------------------------------------------------------------- */
  function tameNewsletterPopup() {
    if (lsGet('newsletter_dismissed') === '1') {
      // Mark as dismissed: hide any popup element that exists
      document.querySelectorAll('.cc-pop-up pop-up, .cc-pop-up .modal.popup-section').forEach(function (el) {
        el.style.display = 'none';
      });
      return;
    }

    // Wait for popup element to exist (Symmetry inserts late)
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      var popup = document.querySelector('pop-up.popup-section, .cc-pop-up pop-up');
      if (popup || attempts > 20) {
        clearInterval(iv);
        if (!popup) return;

        // Force close until 30s, then open
        if (typeof popup.close === 'function') {
          try { popup.close(); } catch (e) {}
        }
        popup.classList.add('invisible');
        popup.setAttribute('aria-hidden', 'true');

        setTimeout(function () {
          if (lsGet('newsletter_dismissed') === '1') return;
          if (typeof popup.open === 'function') {
            try { popup.open(); } catch (e) {}
          } else {
            popup.classList.remove('invisible');
            popup.setAttribute('aria-hidden', 'false');
          }
        }, 30000);

        // Track dismiss
        var closeBtn = popup.querySelector('.js-close-modal, .modal__close-btn');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            lsSet('newsletter_dismissed', '1');
          });
        }
        // Also catch submit-success path
        popup.addEventListener('submit', function () {
          lsSet('newsletter_dismissed', '1');
        }, true);
      }
    }, 250);
  }

  /* ----------------------------------------------------------------------
     P0.2 — Cart drawer: auto-open + trust row + free-shipping subtitle
     ---------------------------------------------------------------------- */
  function enhanceCartDrawer() {
    function injectTrust() {
      document.querySelectorAll('cart-drawer').forEach(function (drawer) {
        if (drawer.querySelector('.bespoky-cart-trust-row')) return;
        var checkoutBtns = drawer.querySelector('.checkout-buttons');
        if (!checkoutBtns) return;

        var shipNote = document.createElement('div');
        shipNote.className = 'bespoky-cart-shipping-note';
        shipNote.textContent = 'Free Worldwide Shipping Included';
        checkoutBtns.parentNode.insertBefore(shipNote, checkoutBtns);

        var row = document.createElement('div');
        row.className = 'bespoky-cart-trust-row';
        row.innerHTML = '' +
          '<span><span class="bespoky-trust-icon">✓</span> 14-Day Returns</span>' +
          '<span><span class="bespoky-trust-icon">✓</span> 12-Month Warranty</span>';
        checkoutBtns.parentNode.insertBefore(row, checkoutBtns.nextSibling);
      });
    }
    injectTrust();

    // Re-inject after drawer refreshes (Symmetry replaces innerHTML on update)
    var mo = new MutationObserver(function (mutations) {
      var needRe = false;
      mutations.forEach(function (m) {
        if (m.type === 'childList' && m.addedNodes.length) needRe = true;
      });
      if (needRe) injectTrust();
    });
    document.querySelectorAll('cart-drawer').forEach(function (d) {
      mo.observe(d, { childList: true, subtree: true });
    });

    // Hook add-to-cart fetch responses for auto-open (Symmetry already does this
    // when settings.after_add_to_cart === 'drawer', but force it here too).
    var origFetch = window.fetch;
    if (origFetch && !window.__bespokyFetchHooked) {
      window.__bespokyFetchHooked = true;
      window.fetch = function () {
        var url = arguments[0];
        var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
        var p = origFetch.apply(this, arguments);
        if (urlStr.indexOf('/cart/add') !== -1) {
          p.then(function (resp) {
            if (!resp || !resp.ok) return;
            // Open the cart drawer
            setTimeout(function () {
              var drawer = document.querySelector('cart-drawer');
              if (drawer && typeof drawer.open === 'function') {
                try { drawer.open(); } catch (e) {}
              } else if (drawer) {
                drawer.setAttribute('aria-hidden', 'false');
                drawer.classList.add('is-open');
              }
              injectTrust();
            }, 150);
          }).catch(function () {});
        }
        return p;
      };
    }
  }

  /* ----------------------------------------------------------------------
     P0.3 — Quick Add on product cards
     Inject button into each .product-block detail area. On click, fetch
     /products/{handle}.js, build mini variant picker, POST to /cart/add.
     ---------------------------------------------------------------------- */
  var qaModal = null;
  var qaState = { product: null, selectedVariantId: null, optionSelections: {} };

  function buildQaModal() {
    if (qaModal) return qaModal;
    qaModal = document.createElement('div');
    qaModal.className = 'bespoky-qa-modal';
    qaModal.setAttribute('role', 'dialog');
    qaModal.setAttribute('aria-modal', 'true');
    qaModal.innerHTML = '' +
      '<div class="bespoky-qa-modal__box">' +
      '  <button type="button" class="bespoky-qa-modal__close" aria-label="Close">×</button>' +
      '  <h3 class="bespoky-qa-modal__title"></h3>' +
      '  <div class="bespoky-qa-modal__price"></div>' +
      '  <div class="bespoky-qa-modal__options"></div>' +
      '  <button type="button" class="bespoky-qa-modal__atc">Add to Cart</button>' +
      '  <a href="#" class="bespoky-qa-modal__viewfull">View full product details</a>' +
      '  <div class="bespoky-qa-modal__error"></div>' +
      '  <div class="bespoky-qa-modal__success">Added to cart!</div>' +
      '</div>';
    document.body.appendChild(qaModal);

    qaModal.querySelector('.bespoky-qa-modal__close').addEventListener('click', closeQa);
    qaModal.addEventListener('click', function (e) {
      if (e.target === qaModal) closeQa();
    });
    qaModal.querySelector('.bespoky-qa-modal__atc').addEventListener('click', qaAddToCart);
    return qaModal;
  }

  function closeQa() {
    if (qaModal) qaModal.classList.remove('is-open');
  }

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyWithCurrencyFormat) || '${{amount}}';
    var dollars = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, dollars);
  }

  function recomputeVariant() {
    if (!qaState.product) return;
    var opts = qaState.product.options.map(function (o, i) {
      return qaState.optionSelections[i] || null;
    });
    var match = qaState.product.variants.find(function (v) {
      return opts.every(function (val, i) { return val !== null && v.options[i] === val; });
    });
    qaState.selectedVariantId = match ? match.id : null;
    var atc = qaModal.querySelector('.bespoky-qa-modal__atc');
    if (match && match.available) {
      atc.disabled = false;
      atc.textContent = 'Add to Cart — ' + formatMoney(match.price);
    } else if (match) {
      atc.disabled = true;
      atc.textContent = 'Sold out';
    } else {
      atc.disabled = true;
      atc.textContent = 'Select options';
    }
  }

  function renderQa(product) {
    buildQaModal();
    qaState.product = product;
    qaState.optionSelections = {};
    qaState.selectedVariantId = null;

    qaModal.querySelector('.bespoky-qa-modal__title').textContent = product.title || '';
    qaModal.querySelector('.bespoky-qa-modal__price').textContent = formatMoney(product.price || (product.variants[0] && product.variants[0].price) || 0);
    qaModal.querySelector('.bespoky-qa-modal__viewfull').setAttribute('href', '/products/' + product.handle);
    qaModal.querySelector('.bespoky-qa-modal__error').classList.remove('is-shown');
    qaModal.querySelector('.bespoky-qa-modal__success').classList.remove('is-shown');

    var optsEl = qaModal.querySelector('.bespoky-qa-modal__options');
    optsEl.innerHTML = '';

    var options = product.options || [];
    options.forEach(function (optName, optIdx) {
      var lbl = document.createElement('div');
      lbl.className = 'bespoky-qa-modal__opt-label';
      lbl.textContent = optName;
      optsEl.appendChild(lbl);

      var values = [];
      product.variants.forEach(function (v) {
        var val = v.options[optIdx];
        if (val && values.indexOf(val) === -1) values.push(val);
      });

      var grid = document.createElement('div');
      grid.className = 'bespoky-qa-modal__opts';
      values.forEach(function (val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bespoky-qa-modal__opt';
        btn.textContent = val;
        btn.dataset.optIdx = String(optIdx);
        btn.dataset.optVal = val;
        // Check availability
        var anyAvail = product.variants.some(function (v) {
          return v.options[optIdx] === val && v.available;
        });
        if (!anyAvail) btn.classList.add('is-unavailable');

        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-unavailable')) return;
          // Deselect siblings
          grid.querySelectorAll('.bespoky-qa-modal__opt').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          qaState.optionSelections[optIdx] = val;
          recomputeVariant();
        });
        grid.appendChild(btn);
      });

      // Auto-select if only one option value
      if (values.length === 1) {
        qaState.optionSelections[optIdx] = values[0];
        var firstBtn = grid.querySelector('.bespoky-qa-modal__opt');
        if (firstBtn) firstBtn.classList.add('is-selected');
      }
      optsEl.appendChild(grid);
    });

    recomputeVariant();
    qaModal.classList.add('is-open');
  }

  function qaAddToCart() {
    if (!qaState.selectedVariantId) return;
    var atc = qaModal.querySelector('.bespoky-qa-modal__atc');
    var errEl = qaModal.querySelector('.bespoky-qa-modal__error');
    var sucEl = qaModal.querySelector('.bespoky-qa-modal__success');
    errEl.classList.remove('is-shown');
    sucEl.classList.remove('is-shown');
    var originalText = atc.textContent;
    atc.disabled = true;
    atc.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: qaState.selectedVariantId, quantity: 1 })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    }).then(function () {
      sucEl.classList.add('is-shown');
      atc.textContent = 'Added ✓';
      setTimeout(function () {
        closeQa();
        // Trigger cart drawer refresh + open
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.refresh === 'function') {
          try { drawer.refresh(); } catch (e) {}
        }
        if (drawer && typeof drawer.open === 'function') {
          try { drawer.open(); } catch (e) {}
        }
      }, 600);
    }).catch(function (err) {
      atc.disabled = false;
      atc.textContent = originalText;
      errEl.textContent = (err && err.description) || (err && err.message) || 'Sorry, could not add to cart.';
      errEl.classList.add('is-shown');
    });
  }

  function attachQuickAdd() {
    document.querySelectorAll('product-block').forEach(function (card) {
      if (card.dataset.bespokyQaAttached) return;
      card.dataset.bespokyQaAttached = '1';

      // Find product handle from .product-link href
      var link = card.querySelector('a.product-link[href*="/products/"]');
      if (!link) return;
      var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) return;
      var handle = match[1];

      // Insert below detail block (inside .innerer)
      var innerer = card.querySelector('.innerer');
      if (!innerer) return;
      if (innerer.querySelector('.bespoky-quick-add')) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bespoky-quick-add';
      btn.textContent = 'Quick add +';
      btn.setAttribute('aria-label', 'Quick add this product');
      btn.dataset.handle = handle;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        btn.innerHTML = '<span class="bespoky-quick-add__spinner"></span>Loading';
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            btn.textContent = 'Quick add +';
            renderQa(product);
          }).catch(function () {
            btn.textContent = 'Quick add +';
            window.location.href = '/products/' + handle;
          });
      });
      innerer.appendChild(btn);
    });
  }

  /* ----------------------------------------------------------------------
     P1.5 — PDP Trust Signal Row
     Inject under .add-to-cart button.
     ---------------------------------------------------------------------- */
  function injectProductTrust() {
    var atc = document.querySelector('button.add-to-cart, .add-to-cart');
    if (!atc) return;
    var atcRow = atc.closest('.quantity-submit-row') || atc.parentNode;
    if (!atcRow || atcRow.parentNode.querySelector('.bespoky-product-trust')) return;

    var iconCheck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    var iconTruck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="15" height="11"/><polygon points="16 8 20 8 23 11 23 17 16 17 16 8"/><circle cx="5.5" cy="20.5" r="2.5"/><circle cx="18.5" cy="20.5" r="2.5"/></svg>';
    var iconClock = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
    var iconReturn = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>';
    var iconShield = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>';

    var row = document.createElement('div');
    row.className = 'bespoky-product-trust';
    row.innerHTML = '' +
      '<div class="bespoky-product-trust__item"><div class="bespoky-product-trust__icon">' + iconTruck + '</div><div class="bespoky-product-trust__label">Free Shipping</div><div>Worldwide</div></div>' +
      '<div class="bespoky-product-trust__item"><div class="bespoky-product-trust__icon">' + iconClock + '</div><div class="bespoky-product-trust__label">Made</div><div>To Order</div></div>' +
      '<div class="bespoky-product-trust__item"><div class="bespoky-product-trust__icon">' + iconReturn + '</div><div class="bespoky-product-trust__label">14-Day</div><div>Returns</div></div>' +
      '<div class="bespoky-product-trust__item"><div class="bespoky-product-trust__icon">' + iconShield + '</div><div class="bespoky-product-trust__label">12-Month</div><div>Warranty</div></div>';

    // Insert after the form (after the row containing ATC)
    var insertAfter = atcRow.closest('form') || atcRow;
    if (insertAfter.parentNode) {
      insertAfter.parentNode.insertBefore(row, insertAfter.nextSibling);
    }
  }

  /* ----------------------------------------------------------------------
     P1.6 — Cookie consent persistence
     Symmetry/Bespoky relies on Shopify's customer privacy API. We persist a
     localStorage flag and hide the banner on subsequent visits when it was
     previously dismissed/accepted.
     ---------------------------------------------------------------------- */
  function persistCookieBanner() {
    // Common selectors for cookie banners across Shopify themes & apps
    var selectors = [
      '#shopify-pc__banner',
      '.shopify-pc__banner',
      '[data-shopify-privacy-banner]',
      '.cookie-banner',
      '#cookieBanner',
      '.cookie-consent',
      '#cookie-notice'
    ];

    function hideAll() {
      selectors.forEach(function (s) {
        document.querySelectorAll(s).forEach(function (el) {
          el.style.display = 'none';
          el.setAttribute('aria-hidden', 'true');
        });
      });
    }

    if (lsGet('cookies_accepted') === '1') {
      hideAll();
      // Watch for late insertion (Shopify privacy banner can mount async)
      var obs = new MutationObserver(function () { hideAll(); });
      obs.observe(document.body, { childList: true, subtree: true });
      // Auto-disconnect after 10s
      setTimeout(function () { obs.disconnect(); }, 10000);
      return;
    }

    // Attach handler to detect dismissal/acceptance
    function attach() {
      selectors.forEach(function (s) {
        document.querySelectorAll(s).forEach(function (banner) {
          if (banner.dataset.bespokyAttached) return;
          banner.dataset.bespokyAttached = '1';
          banner.addEventListener('click', function (e) {
            var target = e.target;
            if (!target) return;
            // Capture any button click as accept/dismiss
            if (target.tagName === 'BUTTON' || target.closest('button, a')) {
              lsSet('cookies_accepted', '1');
              lsSet('cookies_accepted_ts', String(Date.now()));
            }
          }, true);
        });
      });
    }
    attach();
    var mo = new MutationObserver(attach);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  /* ----------------------------------------------------------------------
     P1.7 — Color swatch variant preview on hover
     For each .product-block, intercept hover on .product-block-options__item
     (which has data-media). Find matching .product-block__image by data-media-id
     and toggle --active class.
     ---------------------------------------------------------------------- */
  function attachSwatchHover() {
    document.querySelectorAll('product-block').forEach(function (card) {
      if (card.dataset.bespokyHoverAttached) return;
      card.dataset.bespokyHoverAttached = '1';

      var swatches = card.querySelectorAll('.product-block-options--swatch .product-block-options__item[data-media]');
      if (!swatches.length) return;

      var images = card.querySelectorAll('.product-block__image');
      var originalActive = card.querySelector('.product-block__image--active');

      function activate(mediaId) {
        images.forEach(function (img) {
          if (img.dataset.mediaId === mediaId) {
            img.classList.add('product-block__image--active');
            img.style.opacity = '1';
          } else if (img !== originalActive) {
            img.classList.remove('product-block__image--active');
          }
        });
      }
      function reset() {
        images.forEach(function (img) {
          if (img === originalActive) {
            img.classList.add('product-block__image--active');
            img.style.opacity = '';
          } else {
            img.classList.remove('product-block__image--active');
            img.style.opacity = '';
          }
        });
      }

      swatches.forEach(function (sw) {
        var mediaId = sw.dataset.media;
        if (!mediaId) return;
        sw.addEventListener('mouseenter', function () { activate(mediaId); });
        sw.addEventListener('focus', function () { activate(mediaId); });
      });

      var optsContainer = card.querySelector('.product-block-options--swatch');
      if (optsContainer) {
        optsContainer.addEventListener('mouseleave', reset);
      }
    });
  }

  /* ----------------------------------------------------------------------
     Init
     ---------------------------------------------------------------------- */
  function init() {
    try { tameNewsletterPopup(); } catch (e) { console.warn('[bespoky-simgym] popup:', e); }
    try { enhanceCartDrawer(); } catch (e) { console.warn('[bespoky-simgym] cart:', e); }
    try { attachQuickAdd(); } catch (e) { console.warn('[bespoky-simgym] quickadd:', e); }
    try { injectProductTrust(); } catch (e) { console.warn('[bespoky-simgym] trust:', e); }
    try { persistCookieBanner(); } catch (e) { console.warn('[bespoky-simgym] cookies:', e); }
    try { attachSwatchHover(); } catch (e) { console.warn('[bespoky-simgym] swatch:', e); }

    // Re-attach for dynamically-loaded product cards (infinite scroll, filters)
    var attachObs = new MutationObserver(function () {
      attachQuickAdd();
      attachSwatchHover();
    });
    attachObs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ===== assets/bespoky-wave2-fixes.js ===== */
/* =======================================================================
 * Bespoky Wave 2 Fixes — Sprint 127 (May 18, 2026)
 * SANITIZED Sprint 133 (May 19, 2026):
 *   - REMOVED buildSearchTypeahead() entirely (it wrapped header search
 *     inputs and was the root cause of the v7 header collapse).
 *   - REMOVED the isInHeaderRegion() guard function (now dead code after
 *     buildSearchTypeahead removal; remaining injections target PDP /
 *     product-grid containers only, which never live inside the header).
 *   - REMOVED all `isInHeaderRegion(...)` call sites.
 *   - The header now relies entirely on Symmetry's stock predictive search.
 * Sprint 134 (May 19, 2026): Fix 2 — Shipping accordion text is now
 *   static "Free worldwide shipping" (no country variable). humanizeCountry
 *   is retained as dead-code-safe utility (not invoked).
 *
 * Retained features:
 *   W2.1 Quick Add hardening (collection cards only)
 *   W2.3 Product card extras: swatches + material badge
 *   W2.4 PDP "Browse all {type}" link
 *   W2.5 Country-based delivery accordion on PDP  [Sprint 134: country removed]
 *   W2.6 Brand proof block near PDP buy box  [RESTYLED Sprint 131]
 *   Zero-results page (/search) enhancement
 * ========================================================================== */
(function () {
  'use strict';

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ========================================================================
   * W2.1 — Quick Add production hardening
   * ======================================================================== */
  function quickAddHardening() {
    var REBIND_DELAY = 200;
    var rebindTimer = null;
    function scheduleRebind() {
      if (rebindTimer) clearTimeout(rebindTimer);
      rebindTimer = setTimeout(function () {
        if (typeof window.__bespokyAttachQuickAdd === 'function') {
          try { window.__bespokyAttachQuickAdd(); } catch (e) {}
        }
      }, REBIND_DELAY);
    }

    var gridSelectors = [
      '.product-grid',
      '.collection-listing',
      '.collection-grid',
      'main-collection',
      '[data-product-grid]',
      '.products-grid',
      '.grid--view-items'
    ];
    var grids = [];
    gridSelectors.forEach(function (s) {
      qa(s).forEach(function (el) { if (grids.indexOf(el) === -1) grids.push(el); });
    });

    if (grids.length === 0) return;

    var mo = new MutationObserver(function (muts) {
      var seenNewCard = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes || [], function (n) {
          return n.nodeType === 1 && (
            n.tagName === 'PRODUCT-BLOCK' ||
            (n.querySelector && n.querySelector('product-block'))
          );
        });
      });
      if (seenNewCard) scheduleRebind();
    });
    grids.forEach(function (g) { mo.observe(g, { childList: true, subtree: true }); });

    document.body.setAttribute('data-quick-add-debug', 'loaded');

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.bespoky-quick-add');
      if (!btn) return;
      setTimeout(function () {
        var modal = q('.bespoky-qa-modal.is-open');
        if (!modal && btn.dataset.handle) {
          window.location.href = '/products/' + btn.dataset.handle;
        }
      }, 4000);
    }, true);
  }

  /* ========================================================================
   * Zero-results page enhancement (only on /search template body).
   * ======================================================================== */
  function enhanceZeroResults() {
    if (!/template-search/i.test(document.body.className)) return;
    var noResults = q('.search-no-results, .empty-page-content, [class*="no-results"]');
    if (!noResults) {
      var resultsList = q('.product-grid, .search-results__list');
      if (resultsList && !resultsList.querySelector('product-block, .product-block, .product-card')) {
        var box = document.createElement('div');
        box.className = 'bespoky-search-zero-results';
        box.innerHTML = buildSuggestionHtml();
        resultsList.parentNode.insertBefore(box, resultsList);
      }
      return;
    }
    if (noResults.querySelector('.bespoky-search-zero-results')) return;
    var box2 = document.createElement('div');
    box2.className = 'bespoky-search-zero-results';
    box2.innerHTML = buildSuggestionHtml();
    noResults.appendChild(box2);
  }

  function buildSuggestionHtml() {
    var typoMap = {
      'barfoot': 'barefoot', 'bareffot': 'barefoot', 'barfoot shoes': 'barefoot shoes',
      'chesea': 'chelsea', 'cheslea': 'chelsea',
      'loaffer': 'loafer', 'lofer': 'loafer',
      'sneaker': 'sneakers', 'sneakerz': 'sneakers',
      'oxford': 'oxford shoes'
    };
    var params = new URLSearchParams(window.location.search);
    var qParam = (params.get('q') || '').toLowerCase().trim();
    var didYouMean = '';
    if (qParam && typoMap[qParam]) {
      didYouMean = '<p class="bespoky-did-you-mean">Did you mean <a href="/search?q=' +
        encodeURIComponent(typoMap[qParam]) + '"><strong>' + typoMap[qParam] + '</strong></a>?</p>';
    }
    var suggestions = [
      { label: 'Sneakers', url: '/collections/sneakers' },
      { label: 'Chelsea Boots', url: '/collections/men-boots' },
      { label: 'Slippers', url: '/collections/women-slipper' },
      { label: 'Ballet Flats', url: '/collections/women-sandals-ballets-flat-ballets' },
      { label: 'Loafers', url: '/collections/women-slipper' },
      { label: 'Oxford Shoes', url: '/collections/women-oxford-barefoot-oxford-shoes' }
    ];
    var pills = suggestions.map(function (s) {
      return '<a class="bespoky-search-zero-results__suggestion" href="' + s.url + '">' + s.label + '</a>';
    }).join('');
    var waLink = 'https://wa.me/13025260549?text=' + encodeURIComponent('Hello, I am looking for: ' + (qParam || ''));
    return didYouMean +
           '<h3>Looking for something specific?</h3>' +
           '<p>Try one of our popular categories below:</p>' +
           '<div class="bespoky-search-zero-results__suggestions">' + pills + '</div>' +
           '<p style="margin-top:18px;"><a href="' + waLink + '" target="_blank" rel="noopener" class="bespoky-search-zero-results__suggestion" style="background:#25d366;color:#fff;border-color:#25d366;">Contact us on WhatsApp →</a></p>';
  }

  /* ========================================================================
   * W2.3 — Product card extras
   * ======================================================================== */
  function injectCardExtras() {
    qa('product-block').forEach(function (card) {
      if (card.dataset.bespokyExtrasAttached) return;
      card.dataset.bespokyExtrasAttached = '1';

      var innerer = card.querySelector('.innerer');
      if (!innerer) return;
      if (innerer.querySelector('.bespoky-card-extras')) return;

      var extras = document.createElement('div');
      extras.className = 'bespoky-card-extras';
      var extrasContent = '';

      var swatchItems = card.querySelectorAll('.product-block-options--swatch .product-block-options__item');
      if (swatchItems.length > 0) {
        var swHtml = '';
        var maxShown = Math.min(6, swatchItems.length);
        for (var i = 0; i < maxShown; i++) {
          var sw = swatchItems[i];
          var style = sw.getAttribute('style') || '';
          var bg = '';
          var bgMatch = style.match(/--swatch-background-color:\s*([^;]+)/);
          if (bgMatch) bg = 'background:' + bgMatch[1] + ';';
          else {
            var imgEl = sw.querySelector('img');
            if (imgEl && imgEl.src) bg = 'background-image:url(' + imgEl.src + ');background-size:cover;';
          }
          var name = (sw.getAttribute('data-option-item') || '').replace(/"/g, '&quot;');
          swHtml += '<span class="bespoky-swatch" style="' + bg + '" title="' + name + '" aria-label="' + name + '"></span>';
        }
        var remaining = swatchItems.length - maxShown;
        if (remaining > 0) swHtml += '<span class="bespoky-swatches__more">+' + remaining + '</span>';
        if (swHtml) {
          extrasContent += '<div class="bespoky-card-extras__row"><span class="bespoky-swatches">' + swHtml + '</span></div>';
        }
      }

      var titleEl = card.querySelector('.product-block__title');
      if (titleEl) {
        var title = (titleEl.textContent || '').toLowerCase();
        var material = null;
        if (/suede/.test(title)) material = 'Suede';
        else if (/nubuck/.test(title)) material = 'Nubuck';
        else if (/calf/.test(title)) material = 'Calf Leather';
        else if (/leather/.test(title)) material = 'Leather';
        else if (/shearling|sıcak|fur/.test(title)) material = 'Shearling';
        if (material) {
          extrasContent += '<div class="bespoky-card-extras__row"><span class="bespoky-material-badge">' + material + '</span></div>';
        }
      }

      if (extrasContent) {
        extras.innerHTML = extrasContent;
        var ratingNode = innerer.querySelector('.product-block__rating');
        if (ratingNode) {
          innerer.insertBefore(extras, ratingNode);
        } else {
          innerer.appendChild(extras);
        }
      }
    });
  }

  /* ========================================================================
   * W2.4 — PDP Browse all CTA
   * ======================================================================== */
  function injectBrowseAllPdp() {
    if (!isProductPage()) return;
    if (q('.bespoky-browse-all-link')) return;

    var productType = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.type) ||
      detectProductTypeFromBreadcrumb();
    if (!productType) return;

    var slug = productType.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    if (!slug) return;
    var collectionUrl = '/collections/' + slug;

    var description = q('.product-description, .product__description, [class*="product"][class*="description"]');
    var afterEl = description || q('.product-block-list, .product__info, main');
    if (!afterEl) return;

    var link = document.createElement('a');
    link.className = 'bespoky-browse-all-link';
    link.href = collectionUrl;
    link.textContent = 'Browse all ' + productType + ' →';

    afterEl.parentNode.insertBefore(link, afterEl.nextSibling);
  }

  function isProductPage() {
    return /template-product|product-template/i.test(document.body.className) ||
           !!q('main-product') ||
           !!q('[id*="ProductSection"]') ||
           /^\/products\//.test(window.location.pathname);
  }

  function detectProductTypeFromBreadcrumb() {
    var crumb = qa('.breadcrumb a, [class*="breadcrumb"] a');
    if (!crumb.length) return null;
    for (var i = crumb.length - 1; i >= 0; i--) {
      var text = (crumb[i].textContent || '').trim();
      if (text && !/products?|home/i.test(text)) return text;
    }
    return null;
  }

  /* ========================================================================
   * W2.5 — Shipping accordion (PDP ATC anchored)
   * Sprint 134: text is now static (no country variable)
   * ======================================================================== */
  function injectShippingAccordion() {
    if (!isProductPage()) return;
    if (q('.bespoky-shipping-accordion')) return;

    var atc = q('button.add-to-cart, button[name="add"], .add-to-cart');
    if (!atc) return;

    var details = document.createElement('details');
    details.className = 'bespoky-shipping-accordion';
    details.innerHTML = '' +
      '<summary>📦 Shipping &amp; Returns</summary>' +
      '<ul>' +
      '<li>Free worldwide shipping</li>' +
      '<li>Made to order by hand in our own workshops</li>' +
      '<li>14-day returns (return shipping paid by customer) &middot; 12-month craftsmanship warranty</li>' +
      '<li>Made in Turkey &middot; Genuine calf leather</li>' +
      '</ul>';

    var atcRow = atc.closest('.quantity-submit-row, form, product-form') || atc.parentNode;
    if (atcRow && atcRow.parentNode) {
      atcRow.parentNode.insertBefore(details, atcRow);
    }
  }

  function humanizeCountry(code) {
    /* Sprint 134: retained for backward compat; no longer invoked. */
    if (!code) return null;
    var map = {
      'US': 'United States', 'GB': 'United Kingdom', 'UK': 'United Kingdom',
      'CA': 'Canada', 'AU': 'Australia', 'NZ': 'New Zealand',
      'DE': 'Germany', 'FR': 'France', 'IT': 'Italy', 'ES': 'Spain',
      'NL': 'Netherlands', 'BE': 'Belgium', 'SE': 'Sweden', 'NO': 'Norway',
      'DK': 'Denmark', 'FI': 'Finland', 'IE': 'Ireland', 'AT': 'Austria',
      'CH': 'Switzerland', 'PT': 'Portugal', 'GR': 'Greece', 'PL': 'Poland',
      'CZ': 'Czech Republic', 'JP': 'Japan', 'KR': 'South Korea',
      'SG': 'Singapore', 'HK': 'Hong Kong', 'AE': 'UAE', 'SA': 'Saudi Arabia',
      'IL': 'Israel', 'TR': 'Turkey', 'MX': 'Mexico', 'BR': 'Brazil',
      'IN': 'India', 'ZA': 'South Africa'
    };
    return map[code.toUpperCase()] || code;
  }

  /* ========================================================================
   * W2.6 — Brand proof block (PDP ATC anchored)
   * ======================================================================== */
  function injectBrandProof() {
    if (!isProductPage()) return;
    if (q('.bespoky-brand-proof')) return;

    var atc = q('button.add-to-cart, button[name="add"], .add-to-cart');
    if (!atc) return;

    var block = document.createElement('div');
    block.className = 'bespoky-brand-proof';
    block.innerHTML = '' +
      '<div class="bbp-item">' +
      '  <strong><span class="bbp-icon"></span>Made in Turkey</strong>' +
      '  <span>Hand-stitched in Istanbul atelier since 2018</span>' +
      '</div>' +
      '<div class="bbp-item">' +
      '  <strong><span class="bbp-icon"></span>12-Month Warranty</strong>' +
      '  <span>Covers workmanship and manufacturing defects</span>' +
      '</div>' +
      '<div class="bbp-item">' +
      '  <strong><span class="bbp-icon"></span>Premium Calf Leather</strong>' +
      '  <span>Full-grain &middot; Naturally tanned &middot; Soft &amp; durable</span>' +
      '</div>' +
      '<div class="bbp-item">' +
      '  <strong><span class="bbp-icon"></span>' + ((window.bespokyLooxText && window.bespokyLooxText('store')) || 'Verified customer reviews') + '</strong>' +
      '  <span>' + ((window.bespokyLooxText && window.bespokyLooxText('store')) ? 'Verified buyers via Loox' : 'Verified buyers via Loox &amp; Etsy') + '</span>' +
      '</div>';

    var trustRow = q('.bespoky-product-trust');
    var anchor = trustRow || atc.closest('.quantity-submit-row, form, product-form') || atc.parentNode;
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(block, anchor.nextSibling);
    }
  }

  function init() {
    try { quickAddHardening(); } catch (e) { console.warn('[bespoky-wave2] qa hardening:', e); }
    try { enhanceZeroResults(); } catch (e) { console.warn('[bespoky-wave2] zero-results:', e); }
    try { injectCardExtras(); } catch (e) { console.warn('[bespoky-wave2] card-extras:', e); }
    try { injectBrowseAllPdp(); } catch (e) { console.warn('[bespoky-wave2] browse-all:', e); }
    try { injectShippingAccordion(); } catch (e) { console.warn('[bespoky-wave2] shipping:', e); }
    try { injectBrandProof(); } catch (e) { console.warn('[bespoky-wave2] brand-proof:', e); }

    var gridSelectors = ['.product-grid', '.collection-listing', '.collection-grid',
                          'main-collection', '[data-product-grid]', '.products-grid',
                          '.grid--view-items'];
    gridSelectors.forEach(function (s) {
      qa(s).forEach(function (g) {
        if (g.__bespokyW2Observed) return;
        g.__bespokyW2Observed = true;
        var gObs = new MutationObserver(function () {
          try { injectCardExtras(); } catch (e) {}
        });
        gObs.observe(g, { childList: true, subtree: true });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ===== assets/bespoky-wave3-fixes.js ===== */
/* ==========================================================================
 * Bespoky Wave 3 Fixes — Sprint 128 (May 18, 2026)
 * Sprint 131 (May 18, 2026): VISUAL CLEANUP — W4.3 injectMediaBadges()
 *   DISABLED (call commented out in init).
 * Sprint 133 (May 19, 2026): VERIFIED no header-touching code. File body
 *   unchanged. Operations target /products, /collections, /search, and
 *   bottom-of-page overlays only.
 * Sprint 135 (May 19, 2026): TWO BUG FIXES (Chrome MCP verified)
 *   - Bug 1: Size Guide click handler selector expanded to include
 *     .bespoky-size-guide-fallback (the actual DOM button class).
 *     preventDefault() now runs BEFORE fetch attempt.
 *   - Bug 2: findLooxSection() probe list now starts with the actual
 *     Symmetry+Loox dynamic-block id pattern:
 *     [id*="loox_reviews_loox_dynamic"].
 *   - Bug 2b: Read-reviews click handler ALWAYS preventDefault and has
 *     a scroll fallback when the Loox section cannot be located.
 * Sprint 136 (May 19, 2026): ROBUST SCROLL FIX
 *   - Replaced scrollIntoView() with absolute window.scrollTo math.
 *   - Read-reviews click uses a CAPTURE-phase DELEGATED handler.
 *   - findLooxSection() filters out empty/placeholder elements
 *     (offsetHeight > 50).
 * Sprint 137 (May 19, 2026): FINAL FIX — direct navigation + instant scroll
 *   - Bug A: Size Guide embed approach was unreliable in real browsers
 *     (Shopify CDN cache + browser cache + dynamic injection race).
 *     REPLACED with a SIMPLE direct page navigation to /pages/sizing in
 *     the same tab. Removed ensureEmbeddedSizingSection(),
 *     fetchSizingPage(), embedSizingPage(), and the __bespokySizingHtml
 *     cache entirely.
 *   - Bug B: window.scrollTo behavior smooth silently no-ops in some
 *     browser contexts. ALL scrolls now use behavior 'instant' —
 *     functional > pretty.
 *
 * Implements:
 *  W3.1 Pagination scroll + URL ?page=N preservation
 *  W3.2 Per-size stock indicator on collection cards (IntersectionObserver lazy)
 *  W3.5 Compact bottom-anchored cookie bar with accept-on-scroll
 *  W3.6 Newsletter exit-intent + focus trap + Esc-to-close
 *  W4.3 "AS SEEN IN" media badges (Sprint 134 re-enabled)
 *  W4.5 Loox aggregate rating block above ATC on PDP
 *  Sprint137 Size Guide direct navigation (replaces Sprint134-F1 embed)
 *
 * Loaded as defer; runs after DOMContentLoaded.
 * ========================================================================== */
(function () {
  'use strict';

  /* Sprint 136: shared header offset for absolute scroll math. */
  var BESPOKY_HEADER_OFFSET = 80;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function isProductPage() {
    return /template-product|product-template/i.test(document.body.className) ||
           !!q('main-product') ||
           !!q('[id*="ProductSection"]') ||
           /^\/products\//.test(window.location.pathname);
  }
  function isCollectionPage() {
    return /template-collection|template-search/i.test(document.body.className) ||
           /^\/collections\//.test(window.location.pathname);
  }

  /* Sprint 136: robust absolute scroll. Trust window.scrollTo over
     scrollIntoView, which silently no-ops on freshly-revealed or
     dynamically-injected blocks.
     Sprint 137: behavior is 'instant' — smooth scroll is unreliable in
     some browser/page combinations (gets interrupted or silently no-ops).
     Instant jump completes synchronously and cannot be cancelled. */
  function bespokyScrollToEl(el, extraOffset) {
    if (!el || typeof el.getBoundingClientRect !== 'function') return false;
    var rect = el.getBoundingClientRect();
    var absY = rect.top + (window.scrollY || window.pageYOffset || 0);
    var off = typeof extraOffset === 'number' ? extraOffset : BESPOKY_HEADER_OFFSET;
    var top = Math.max(0, absY - off);
    try {
      window.scrollTo({ top: top, behavior: 'instant' });
    } catch (e) {
      window.scrollTo(0, top);
    }
    return true;
  }

  /* ========================================================================
   * W3.1 — Pagination scroll + ?page=N URL behavior
   * ======================================================================== */
  function paginationEnhancements() {
    var grid = q('.product-grid, .collection-listing, .collection-grid, .grid--view-items, main-collection');
    if (!grid) return;
    grid.classList.add('bespoky-pagination-anchor');

    var params = new URLSearchParams(window.location.search);
    var currentPage = parseInt(params.get('page') || '1', 10);
    qa('.pagination a, nav.pagination a, .pagination__item a').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var m = href.match(/[?&]page=(\d+)/);
      var linkPage = m ? parseInt(m[1], 10) : (link.textContent.trim() === '1' ? 1 : null);
      if (linkPage === currentPage) {
        link.classList.add('current');
        link.setAttribute('aria-current', 'page');
      }
    });

    qa('.pagination a, nav.pagination a').forEach(function (link) {
      if (link.__bespokyPagBound) return;
      link.__bespokyPagBound = true;
      link.addEventListener('click', function (e) {
        try { localStorage.setItem('bespoky_paginate_scroll', '1'); } catch (e2) {}
      });
    });

    try {
      if (localStorage.getItem('bespoky_paginate_scroll') === '1') {
        localStorage.removeItem('bespoky_paginate_scroll');
        setTimeout(function () {
          var target = q('.bespoky-pagination-anchor');
          if (target) bespokyScrollToEl(target);
        }, 100);
      }
    } catch (e) {}
  }

  /* ========================================================================
   * W3.2 — Per-size stock indicator (lazy via IntersectionObserver)
   * ======================================================================== */
  function lowStockBadges() {
    if (!isCollectionPage()) return;
    var cache = window.__bespokyStockCache = window.__bespokyStockCache || {};

    function applyBadge(card, payload) {
      if (!payload) return;
      if (card.querySelector('.bespoky-low-stock-badge')) return;
      var lowSizes = payload.lowSizes || [];
      var minQty = payload.minQty;
      if (!lowSizes.length) return;
      var badge = document.createElement('div');
      badge.className = 'bespoky-low-stock-badge' + (minQty <= 2 ? '' : ' bespoky-low-stock-badge--warning');
      if (lowSizes.length === 1) {
        badge.textContent = 'Only ' + minQty + ' left · size ' + lowSizes[0];
      } else {
        badge.textContent = 'Low stock · ' + lowSizes.length + ' sizes';
      }
      card.appendChild(badge);
    }

    function fetchAndApply(card, handle) {
      if (cache[handle]) { applyBadge(card, cache[handle]); return; }
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var variants = data && data.variants ? data.variants : [];
          var lowSizes = [];
          var minQty = 99;
          variants.forEach(function (v) {
            if (typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0 && v.inventory_quantity < 5) {
              var sizeLabel = '';
              ['option1', 'option2', 'option3'].forEach(function (o) {
                if (v[o] && /^\d+([.,]\d)?$|^(XS|S|M|L|XL|XXL)$/i.test(String(v[o]).trim())) sizeLabel = v[o];
              });
              if (!sizeLabel) sizeLabel = v.option1 || '';
              if (sizeLabel) lowSizes.push(sizeLabel);
              if (v.inventory_quantity < minQty) minQty = v.inventory_quantity;
            }
          });
          var payload = { lowSizes: lowSizes, minQty: minQty };
          cache[handle] = payload;
          applyBadge(card, payload);
        })
        .catch(function () { cache[handle] = { lowSizes: [], minQty: 0 }; });
    }

    function extractHandle(card) {
      if (card.dataset && card.dataset.handle) return card.dataset.handle;
      var link = card.querySelector('a[href*="/products/"]');
      if (link) {
        var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (m) return m[1];
      }
      return null;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        io.unobserve(card);
        var handle = extractHandle(card);
        if (handle) fetchAndApply(card, handle);
      });
    }, { rootMargin: '200px 0px' });

    qa('product-block, .product-block, .product-card').forEach(function (card) {
      if (card.__bespokyStockObserved) return;
      card.__bespokyStockObserved = true;
      io.observe(card);
    });

    var grids = qa('.product-grid, .collection-listing, .collection-grid, .grid--view-items, main-collection');
    grids.forEach(function (grid) {
      if (grid.__bespokyStockObsAttached) return;
      grid.__bespokyStockObsAttached = true;
      var mo = new MutationObserver(function () {
        qa('product-block, .product-block, .product-card', grid).forEach(function (card) {
          if (card.__bespokyStockObserved) return;
          card.__bespokyStockObserved = true;
          io.observe(card);
        });
      });
      mo.observe(grid, { childList: true, subtree: true });
    });
  }

  /* ========================================================================
   * W3.5 — Compact bottom-anchored cookie bar
   * ======================================================================== */
  function cookieBar() {
    try {
      if (localStorage.getItem('bespoky_cookie_accepted') === '1') return;
    } catch (e) {}

    var bar = document.createElement('div');
    bar.id = 'bespoky-cookie-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Cookie consent');
    bar.innerHTML = '<span>We use cookies to enhance your experience and analyze traffic. ' +
                    '<a href="/policies/privacy-policy">Learn more</a></span>' +
                    '<button id="bespoky-cookie-accept" type="button">Accept</button>';
    document.body.appendChild(bar);

    setTimeout(function () { bar.classList.add('is-visible'); }, 400);

    function accept() {
      try { localStorage.setItem('bespoky_cookie_accepted', '1'); } catch (e) {}
      bar.classList.remove('is-visible');
      setTimeout(function () { if (bar.parentNode) bar.parentNode.removeChild(bar); }, 350);
    }

    var btn = bar.querySelector('#bespoky-cookie-accept');
    btn.addEventListener('click', accept);

    var scrollHandler = function () {
      if (window.scrollY > 1000) {
        window.removeEventListener('scroll', scrollHandler);
        accept();
      }
    };
    window.addEventListener('scroll', scrollHandler, { passive: true });
  }

  /* ========================================================================
   * W3.6 — Newsletter exit-intent + focus trap
   * ======================================================================== */
  function newsletterEnhance() {
    function findToast() { return q('#bespoky-newsletter-toast, .bespoky-newsletter-toast'); }

    function openToast() {
      var toast = findToast();
      if (!toast) return;
      if (toast.classList.contains('is-open') || toast.classList.contains('show')) return;
      try {
        if (localStorage.getItem('bespoky_newsletter_seen') === '1') return;
      } catch (e) {}
      toast.classList.add('is-open');
      toast.classList.add('show');
      try { localStorage.setItem('bespoky_newsletter_seen', '1'); } catch (e) {}
      trapFocus(toast);
    }

    function trapFocus(modal) {
      var focusables = qa('a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])', modal);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      setTimeout(function () { try { first.focus(); } catch (e) {} }, 100);

      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          modal.classList.remove('is-open');
          modal.classList.remove('show');
        }
        if (e.key !== 'Tab') return;
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      });
    }

    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      var fired = false;
      document.addEventListener('mouseout', function (e) {
        if (fired) return;
        if (!e.relatedTarget && e.clientY <= 0) {
          fired = true;
          openToast();
        }
      });
    }
  }

  /* ========================================================================
   * W4.3 — AS SEEN IN media badges  [Sprint 134: re-enabled]
   * Subtle italic serif row with abstract SVG initials.
   * ======================================================================== */
  function injectMediaBadges() {
    if (!isProductPage()) return;
    if (q('.bespoky-media-badges')) return;

    var atc = q('button.add-to-cart, button[name="add"], .add-to-cart');
    if (!atc) return;

    var brandProof = q('.bespoky-brand-proof');
    var anchor = brandProof || atc.closest('.quantity-submit-row, form, product-form') || atc.parentNode;
    if (!anchor || !anchor.parentNode) return;

    var badges = [
      { name: 'Vogue',   initials: 'V'  },
      { name: 'Esquire', initials: 'Es' },
      { name: 'Times',   initials: 'T'  },
      { name: 'GQ',      initials: 'GQ' }
    ];

    function svg(initials) {
      return '<svg class="bespoky-media-badge__svg" viewBox="0 0 40 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
             '<text x="50%" y="55%" dominant-baseline="middle" text-anchor="middle" font-family="Georgia, serif" font-style="italic" font-size="13" fill="currentColor">' +
             initials + '</text></svg>';
    }

    var row = badges.map(function (b, i) {
      var sep = i < badges.length - 1 ? '<span class="bespoky-media-badge__dot" aria-hidden="true">•</span>' : '';
      return '<span class="bespoky-media-badge" title="' + b.name + '">' + svg(b.initials) + '<span class="bespoky-media-badge__name">' + b.name + '</span></span>' + sep;
    }).join('');

    var block = document.createElement('div');
    block.className = 'bespoky-media-badges';
    block.innerHTML = '<div class="bespoky-media-badges__title">As seen in</div>' +
                     '<div class="bespoky-media-badges__row">' + row + '</div>' +
                     '<a class="bespoky-care-link" href="/pages/shoe-care-tips">Learn how to care for your leather →</a>';

    /* Insert ABOVE brand-proof if it exists; else after the ATC row. */
    if (brandProof) {
      brandProof.parentNode.insertBefore(block, brandProof);
    } else {
      anchor.parentNode.insertBefore(block, anchor.nextSibling);
    }
  }

  /* ========================================================================
   * W4.5 — Loox aggregate rating badge above ATC
   * Sprint 136: Robust capture-phase click handler; window.scrollTo with
   * absolute Y; offsetHeight > 50 filter to skip empty placeholders.
   * Sprint 137: All scrolls behavior 'instant' (smooth no-ops in some
   * browser contexts).
   * ======================================================================== */
  function findLooxSection() {
    var selectors = [
      '[id*="loox_reviews_loox_dynamic"]',
      '[id*="loox_reviews"]',
      'section[id*="loox"]',
      '#loox-reviews',
      '.loox-reviews-default',
      '[data-loox-block]',
      'div[id^="loox-"]',
      'div[class*="loox-"]',
      '#looxReviews',
      '.loox-reviews',
      '[id*="Loox"]',
      '[class*="loox"]',
      '[id*="reviews-section"]',
      '[class*="reviews-section"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var k = 0; k < nodes.length; k++) {
        var n = nodes[k];
        if (n && n.offsetHeight > 50) return n;
      }
    }
    /* Last resort: an h2/h3 whose text starts with Reviews. */
    var heads = qa('h2, h3');
    for (var j = 0; j < heads.length; j++) {
      var t = (heads[j].textContent || '').trim().toLowerCase();
      if (/^(reviews|customer reviews)\b/.test(t)) return heads[j];
    }
    return null;
  }

  /* Sprint 136: SINGLE delegated capture-phase handler bound once. Runs
     before any theme handler can no-op the scroll.
     Sprint 137: fallback scrollTo also uses behavior 'instant'. */
  function bindReadReviewsClickCapture() {
    if (window.__bespokyReadReviewsBound) return;
    window.__bespokyReadReviewsBound = true;

    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest && e.target.closest('.bespoky-read-reviews');
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();

      var target = findLooxSection();
      if (target) {
        bespokyScrollToEl(target, BESPOKY_HEADER_OFFSET);
        return;
      }
      /* Fallback: jump near the bottom where Loox dynamic block usually
         renders once it finishes async-loading. Sprint 137: instant. */
      try {
        window.scrollTo({
          top: Math.max(0, document.body.scrollHeight - window.innerHeight),
          behavior: 'instant'
        });
      } catch (err) {
        window.scrollTo(0, Math.max(0, document.body.scrollHeight - window.innerHeight));
      }
    }, true); /* CAPTURE phase: run FIRST, before any theme handler. */
  }

  function injectLooxAggregate() {
    if (!isProductPage()) return;
    if (q('.bespoky-loox-aggregate')) return;

    var atc = q('button.add-to-cart, button[name="add"], .add-to-cart');
    if (!atc) return;

    var rating = '';
    var count = '';
    var metaRating = document.querySelector('[data-loox-rating], meta[itemprop="ratingValue"]');
    if (metaRating) {
      rating = metaRating.getAttribute('content') || metaRating.getAttribute('data-loox-rating') || rating;
    }
    var metaCount = document.querySelector('[data-loox-count], meta[itemprop="reviewCount"]');
    if (metaCount) {
      count = metaCount.getAttribute('content') || metaCount.getAttribute('data-loox-count') || count;
    }

    var badge = document.createElement('div');
    badge.className = 'bespoky-loox-aggregate';
    badge.innerHTML = '<span class="stars" aria-hidden="true">★★★★★</span>' +
                     '<span class="count">' + ((window.bespokyLooxText && window.bespokyLooxText('product')) || ((rating && count) ? (rating + ' from ' + count + ' reviews') : 'Verified customer reviews')) + '</span>' +
                     '<a href="javascript:void(0)" class="bespoky-read-reviews" role="button">Read reviews →</a>';

    var atcRow = atc.closest('.quantity-submit-row, form, product-form') || atc.parentNode;
    if (atcRow && atcRow.parentNode) {
      atcRow.parentNode.insertBefore(badge, atcRow);
    }

    /* Click binding lives in bindReadReviewsClickCapture(). No per-element listener. */
  }

  /* ========================================================================
   * Sprint 137 — Size Guide: direct navigation (replaces Sprint134-F1 embed)
   *   The fetch-and-embed approach was unreliable in real browsers (Shopify
   *   CDN cache + browser cache + dynamic injection race). REPLACED with a
   *   simple same-tab navigation to /pages/sizing.
   *   NOTE: <a href="/pages/sizing"> anchors are NOT intercepted — they
   *   navigate natively. Only button-style triggers
   *   (.bespoky-size-guide-fallback, .size-chart-link,
   *   button[data-bespoky-size-guide]) get the JS handler.
   * ======================================================================== */
  function bindSizeGuideClick() {
    document.addEventListener('click', function (e) {
      var target = e.target && e.target.closest && e.target.closest('.bespoky-size-guide-fallback, .size-chart-link, button[data-bespoky-size-guide]');
      if (!target) return;
      /* For the button-style triggers, navigate to /pages/sizing in same tab */
      e.preventDefault();
      window.location.href = '/pages/sizing';
    }, true);
  }

  function init() {
    /* Sprint 136: install the read-reviews capture handler EARLY,
       before any other init step, so it's live as soon as the badge
       (or any future element with .bespoky-read-reviews) lands in the DOM. */
    try { bindReadReviewsClickCapture(); } catch (e) { console.warn('[bespoky-wave3] read-reviews-bind:', e); }
    /* Sprint 137: size guide is a simple delegated click → navigation. */
    try { bindSizeGuideClick(); } catch (e) { console.warn('[bespoky-wave3] size-guide-bind:', e); }

    try { paginationEnhancements(); } catch (e) { console.warn('[bespoky-wave3] pagination:', e); }
    try { lowStockBadges(); } catch (e) { console.warn('[bespoky-wave3] low-stock:', e); }
    try { cookieBar(); } catch (e) { console.warn('[bespoky-wave3] cookie:', e); }
    try { newsletterEnhance(); } catch (e) { console.warn('[bespoky-wave3] newsletter:', e); }
    try { injectLooxAggregate(); } catch (e) { console.warn('[bespoky-wave3] loox-aggregate:', e); }
    try { injectMediaBadges(); } catch (e) { console.warn('[bespoky-wave3] media-badges:', e); }

    setTimeout(function () {
      try { injectLooxAggregate(); } catch (e) {}
      try { injectMediaBadges(); } catch (e) {}
    }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();